// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n@media (max-width: 400px) {\n.user-page.m-portlet.m-portlet--responsive-mobile\n    .m-portlet__head\n    .m-portlet__head-tools {\n    width: auto;\n}\n.user-page.m-portlet.m-portlet--responsive-mobile\n    .m-portlet__head\n    .m-portlet__head-tools\n    > * {\n    width: auto;\n}\n}\n", ""]);
// Exports
module.exports = exports;
